<template>
  <w-tool-tabs class="tab-button sub" v-model="activeTab" style="margin-top: -8px;">
    <div slot="tool">
      <!-- <span v-if="activeTab === 'WDeviceList'">
      <el-button icon="fas fa-file-excel" size="small" @click="$refs.deviceList.$options.methods.exportExcel">엑셀출력</el-button>
      <w-header-search-button @click="$refs.deviceList.showSearchTool = !$refs.deviceList.showSearchTool"/>
    </span> -->
    </div>
    <el-tab-pane label="장비목록" name="WDeviceListView">
      <w-controller-config-table ref="deviceList" :activeTab="activeTab" :active="active" />
      <!-- <w-device-list-view ref="deviceList" :activeTab="activeTab" :active="active" /> -->
    </el-tab-pane>
    <el-tab-pane label="컨피그 정보" name="WDeviceConfigInfoView">
      <w-device-config-info-view :activeTab="activeTab" :active="active" />
    </el-tab-pane>
    <el-tab-pane label="정기점검 현황" name="WDeviceRegularCheckView">
      <w-device-regular-check-view :activeTab="activeTab" :active="active" />
    </el-tab-pane>
    <!-- <el-tab-pane label="선번장관리" name="precedenceManageView">
  </el-tab-pane> -->
    <el-tab-pane label="정책위배현황" name="WDevicePolicyViolationView">
      <w-device-policy-violation-view :activeTab="activeTab" :active="active" />
    </el-tab-pane>
    <el-tab-pane label="장비계정" name="WDeviceAccountView">
      <w-device-account-view :activeTab="activeTab" :active="active" />
    </el-tab-pane>
  </w-tool-tabs>
</template>

<script>
import WDeviceListView from '@/views/config/group/netdevice/components/DeviceListView';
import WDeviceConfigInfoView from '@/views/config/group/netdevice/components/DeviceConfigInfoView';
import WDeviceRegularCheckView from '@/views/config/group/netdevice/components/DeviceRegularCheckView';
import WDeviceAccountView from '@/views/config/group/netdevice/components/DeviceAccountView';
import WDevicePolicyViolationView from '@/views/config/group/netdevice/components/DevicePolicyViolationView';
import WControllerConfigTable from './ControllerConfigTable';

export default {
  name: 'WConfigControllerGroup',
  components: {
    WControllerConfigTable,
    WDeviceListView,
    WDeviceConfigInfoView,
    WDeviceRegularCheckView,
    WDeviceAccountView,
    WDevicePolicyViolationView,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      activeTab: 'WDeviceListView',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/group/wireless/components/ConfigControllerGroup.vue